var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"fake-button"},[_vm._v(" ")]),_c('transition',{attrs:{"name":"slide","appear":""}},[_c('MultiselectButtonGroup',{attrs:{"buttons":_vm.buttons}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }